const euro = Intl.NumberFormat('de-DE', {
	style: 'currency',
	currency: 'EUR',
});

const euroRounded = Intl.NumberFormat('de-DE', {
	style: 'currency',
	currency: 'EUR',
	minimumFractionDigits: 0,
	maximumFractionDigits: 0,
});

export const formatPrice = (
	price: number,
	showCurrency = true,
	rounded = false
) => {
	const formatter = rounded ? euroRounded : euro;

	if (!showCurrency) {
		return formatter
			.formatToParts(price)
			.filter(({ type }) => type !== 'currency')
			.map(({ value }) => value)
			.join('')
			.trim();
	}

	return formatter.format(price);
};

export const formatPriceCompact = (price: number) => {
	const hasDecimals = price % 1 !== 0;

	if (price === 0 || hasDecimals) {
		return euro.format(price).replace(/\s/g, '');
	}
	return euroRounded.format(price).replace(/\s/g, '');
};
